<template>
  <layout drawerShow>
    <template slot="nav">
      <nav-exports/>
    </template>
    <template slot="drawer">
      <v-form>
        <v-subheader light class="pa-0 ma-0">Réservation</v-subheader>

      </v-form>
    </template>
    <template slot="content">
      <v-container fluid>
        <v-row>
          <v-col cols="12" sm="6" md="4">
            <v-card>
              <v-card-title>Import JRB</v-card-title>
              <v-divider/>
              <v-card-text>
                <document-uploader
                    url="/api/accounting/export/inqom/lettering"
                    acceptedFiles=".csv"
                    @uploaded="uploaded"
                    @error="onError"
                />
              </v-card-text>
            </v-card>
          </v-col>
        </v-row>
        <smart-dialog v-model="dialog" width="1200" @close="close" class="tbl">
          <v-card v-if="dialog" class="pa-2">


            <div v-for="(file,fileIndex) in files" :key="file.file" class="mt-4">


              <v-row class="align-center">
                <v-col cols="10">
                  <h3 class="d-flex align-center">{{ file.file }} • Remise: {{file.remiseId}}</h3>
                </v-col>
                <v-col class="d-flex justify-end pr-5">
                  <smart-btn secondary small @click.native="lettering(file,fileIndex)" :disabled="!file.matching || loading" :loading="file.loading" class="d-inline-flex right">Lettrer</smart-btn>
                </v-col>
              </v-row>

              <template v-if="!file.remises">
                Impossible de trouver la remise dans inqom.
              </template>
              <v-data-table v-else
                  :headers="headers"
                  :items="file.lines"
                  class="elevation-1 mt-2"
                  hide-default-footer disable-pagination
              >
                <template #body.prepend>
                  <tr class="blue lighten-5" v-for="remise in file.remises" :key="remise.Id">
                    <td></td>
                    <td></td>
                    <td></td>
                    <td>{{ remise.Id }}</td>
                    <td>
                      {{ remise.Label }}
                    </td>
                    <td class="text-right">
                      {{ remise.DebitAmount }}
                    </td>
                    <td class="text-right">
                      {{ remise.CreditAmount }}
                    </td>
                    <td class="text-right">
                      {{ remise.Letter }}
                    </td>
                  </tr>
                </template>
                <template #item.dossier="{item}">
                  {{ item[0].orderId }}
                </template>
                <template #item.remiseType="{item}">
                  {{ item[0].remiseType }}
                </template>
                <template #item.amount="{item}">
                  {{ item[0].amount }}
                </template>
                <template #item.inqomId="{item}">
                  <template v-if="item[1]">{{ item[1].Id }}</template>
                </template>
                <template #item.inqomLabel="{item}">
                  <template v-if="item[1]">{{ item[1].Label }}</template>
                </template>
                <template #item.inqomDebit="{item}">
                  <template v-if="item[1]">{{ item[1].DebitAmount }}</template>
                </template>
                <template #item.inqomCredit="{item}">
                  <template v-if="item[1]">{{ item[1].CreditAmount }}</template>
                </template>
                <template #item.inqomLetter="{item}">
                  <template v-if="item[1]">{{ item[1].Letter }}</template>
                </template>


                <template #body.append>
                  <tr>
                    <td></td>
                    <td></td>
                    <td></td>
                    <td></td>
                    <td class="text-right pr-4">
                      Total
                    </td>
                    <td class="text-right">
                      {{file.totalDebit}}
                    </td>
                    <td class="text-right">
                      {{file.totalCredit}}
                    </td>
                    <td></td>
                  </tr>
                </template>
              </v-data-table>
            </div>

          </v-card>
          <template #actions>
            <smart-btn @click.native="letteringAll" :disabled="!canLetterAll">Lettrer toutes les remises</smart-btn>
          </template>
        </smart-dialog>
      </v-container>
    </template>
  </layout>
</template>
<script>

import DocumentUploader from "@/components/commons/DocumentUploader.vue";
import Layout from "@/views/Layout.vue";
import Availability from "@/components/commons/Availability.vue";
import FormMixin from "@/components/mixins/FormMixin";
import NavExports from "@/views/accounting/exports/NavExports.vue";
import { get, post } from "@/utils/api";

export default {
  name: "SupplierInvoiceImports",
  mixins: [FormMixin],
  components: {Layout, DocumentUploader, Availability, NavExports,},
  props: [],
  data: () => ({
    headers: [
      {text: '#', value: 'dossier'},
      {text: 'type', value: 'remiseType'},
      {text: 'amount', value: 'amount'},
      {text: 'Inqom id', value: 'inqomId'},
      {text: 'Inqom label', value: 'inqomLabel'},
      {text: 'Inqom Debit', value: 'inqomDebit', align: 'right'},
      {text: 'Inqom Credit', value: 'inqomCredit', align: 'right'},
      {text: 'Inqom Letter', value: 'inqomLetter', align: 'right'},
    ],
    dialog: false,
    loading: false,
    files: [

    ]
  }),
  computed:{
    canLetterAll() {
      return this.files.every(f => !f.loading) && this.files.findIndex(f => f.matching) > -1
    }
  },
  methods: {
    uploaded(data) {

      if (data.length > 0) {
        this.files = JSON.parse(data[0].xhr.responseText)
      }
      this.dialog = true
    },
    onError() {
    },
    close() {
      this.files = [];
      this.dialog = false;
    },
    letteringAll(){
      this.loading=true
      post('/api/accounting/export/inqom/lettering/create/all', this.files)
      .json(response => {
        this.close()
      }).finally(() => {
        this.loading=false
      })
    },
    lettering(file, index){
      this.files[index].loading=true
      post('/api/accounting/export/inqom/lettering/create', file)
          .json(response => {
            this.files[index].matching=false
          }).finally(() => {
        this.files[index].loading=false
      })
    }
  }
}
</script>